import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';
interface BackgroundMusicToggleProps {
  isPlaying: boolean;
  onToggle: () => void;
}
export function BackgroundMusicToggle({
  isPlaying,
  onToggle
}: BackgroundMusicToggleProps) {
  return <button onClick={onToggle} className="fixed bottom-20 right-4 z-50" aria-label={isPlaying ? 'Silenciar música' : 'Activar música'} title={isPlaying ? 'Silenciar música' : 'Activar música'} data-id="element-5">
      <div className={`
        flex items-center justify-center h-9 w-9 rounded-full backdrop-blur-md border shadow-md transition-all duration-300
        ${isPlaying ? 'bg-violet-600/70 border-violet-400/30 text-white' : 'bg-white/70 border-slate-200/50 text-slate-400 hover:text-violet-500'}
      `} data-id="element-6">
        {isPlaying ? <Volume2 className="h-4 w-4" data-id="element-7" /> : <VolumeX className="h-4 w-4" data-id="element-8" />}
      </div>
    </button>;
}